import { MESSAGE_KEY_FETCH_FORM_DATA, MESSAGE_KEY_SUBMIT_FORM } from "../../core/const/Constant";
import { doPostMessage, subscribeMessage, subscribeMessageOnce } from "../../core/services/MessageService";
import Utils from "../utils/Common.util";
import { API_ENDPOINT, GET, POST, apiCaching, needForwardToIFrame } from "./_base.api";


const forwardToIFrame = {
    getForm: (formUUID) => {
        return new Promise(next => {
            subscribeMessageOnce(MESSAGE_KEY_FETCH_FORM_DATA, async data => {
                next(data);
            })
            if (typeof formUUID === 'string') {
                doPostMessage(MESSAGE_KEY_FETCH_FORM_DATA, formUUID)
            }
        })
    },
    submitForm: async (uuid, formData) => {
        return new Promise(next => {
            subscribeMessageOnce(MESSAGE_KEY_SUBMIT_FORM, async data => {
                next(data);
            })
            if (typeof uuid === 'string') {
                doPostMessage(MESSAGE_KEY_SUBMIT_FORM, { uuid, formData })
            }
        })
    },
}

const subcribeFromIFrame = {
    getForm() {
        subscribeMessage(MESSAGE_KEY_FETCH_FORM_DATA, async formUUID => {
            if (!Utils.IsIFrame()) {
                return;
            }
            const data = await getForm(formUUID);
            doPostMessage(MESSAGE_KEY_FETCH_FORM_DATA, data)
        })
    },
    submitForm() {
        subscribeMessage(MESSAGE_KEY_SUBMIT_FORM, async (value) => {
            if (!Utils.IsIFrame()) {
                return;
            }
            const { uuid, formData } = value;
            const json = await submitForm(uuid, formData);
            doPostMessage(MESSAGE_KEY_SUBMIT_FORM, json)
        })
    },
    subcribeAll() {
        subcribeFromIFrame.getForm();
        subcribeFromIFrame.submitForm();
    }
}

subcribeFromIFrame.subcribeAll();

export const getForm = async (uuid = '') => {
    if (needForwardToIFrame()) {
        return forwardToIFrame.getForm(uuid);
    }

    if (apiCaching.has(uuid)) {
        return apiCaching.get(uuid);
    }

    const url = `${API_ENDPOINT}/form?uuid=${uuid}`;
    const json = await GET(url);
    apiCaching.set(uuid, json);
    return json;
}

export const submitForm = async (uuid, formData) => {
    if (needForwardToIFrame()) {
        return forwardToIFrame.submitForm(uuid, formData);
    }
    const url = `${API_ENDPOINT}/form?uuid=${uuid}`;
    const json = await POST(url, JSON.stringify(formData));
    return json;
}
